"use strict";var _interopRequireDefault = require("D:\\work\\svn\\\u5BB6\u7528\u540E\u53F0\\branches\\20240430-1.5.0\\node_modules\\@babel\\runtime/helpers/interopRequireDefault");Object.defineProperty(exports, "__esModule", { value: true });exports.default = void 0;require("core-js/modules/es6.function.name");require("core-js/modules/web.dom.iterable");













var _groupSkillLayout = _interopRequireDefault(require("./skill/groupSkillLayout")); //
//
//
//
//
//
//
//
//
//
//
//
//
var _default = { name: 'TaskSkillGroup', components: { GroupSkillLayout: _groupSkillLayout.default }, data: function data() {return { taskId: '', flowId: '', params: [], editableTabsValue: '11', editableTabs: [] };
  },
  methods: {
    handleGetSkillGroupData: function handleGetSkillGroupData(taskId, flowId) {
      var self = this;
      self.editableTabs = [];
      self.taskId = taskId;
      self.flowId = flowId;
      var path = ' /api/temi/robot/task/' + taskId + '/flow/' + flowId + '/taskSkill/groups';
      self.getData(path, {}, function (res) {
        // self.triggerCodeList = res
        console.log('skillGroup', res);
        if (res.length === 0) {
          self.handleAddDefault(taskId, flowId);
        } else {
          var i = 1;
          res.forEach(function (element) {
            var tab = {
              'title': '任务序列' + i,
              'name': '1' + i,
              'content': '1',
              'taskSkill': {
                'id': element.id,
                'isStay': element.isStay ? '1' : '0',
                'taskId': taskId,
                'flowId': flowId,
                'orderNum': element.orderNum,
                'skills': element.skills,
                'stayTime': element.stayTime } };


            self.editableTabs.push(tab);
            i++;
          });
          console.log('tabs', self.editableTabs);
        }
      });
    },
    handleAddDefault: function handleAddDefault(taskId, flowId) {
      var tab = {
        'title': '任务序列1',
        'name': '11',
        'content': '11',
        'taskSkill': {
          'isStay': '0',
          'taskId': taskId,
          'flowId': flowId,
          'orderNum': '1',
          'skills': [],
          'stayTime': '' } };


      this.editableTabs = [];
      this.editableTabs.push(tab);
    },
    handleTabsEdit: function handleTabsEdit(targetName, action) {
      var self = this;
      if (action === 'add') {
        var index = self.editableTabs.length + 1;
        var last = self.editableTabs[self.editableTabs.length - 1];
        var orderNum = last.taskSkill.orderNum + 1;
        console.log('last', last);
        var tab = {
          'title': '任务序列' + index,
          'name': '1' + orderNum,
          'content': '11',
          'taskSkill': {
            'isStay': '0',
            'taskId': self.taskId,
            'flowId': self.flowId,
            'orderNum': orderNum,
            'skills': [],
            'stayTime': '' } };


        this.editableTabs.push(tab);
        console.log('tabs', self.editableTabs);
      }
      if (action === 'remove') {
        var activeName = self.editableTabsValue;
        var tabs = self.editableTabs;
        if (activeName === targetName) {
          tabs.forEach(function (tab, index) {
            if (tab.name === targetName) {
              var nextTab = tabs[index + 1] || tabs[index - 1];
              if (nextTab) {
                activeName = nextTab.name;
              }
            }
          });
        }
        var _tab = tabs.filter(function (tab) {return tab.name === targetName;})[0];
        self.handleRemoveTab(_tab, activeName, targetName);
      }
    },
    handleTips: function handleTips(activeName, oldActiveName) {
      this.$message({
        message: '请记得保存已编辑的任务!',
        type: 'warning' });

    },
    handleRemoveTab: function handleRemoveTab(tab, activeName, targetName) {
      var self = this;
      self.$confirm('确定删除该记录吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        center: true }).
      then(function () {
        if (tab.taskSkill.id) {
          var path = '/api/temi/robot/task/' + tab.taskSkill.taskId + '/flow/' + tab.taskSkill.flowId + '/taskSkill/groups/' + tab.taskSkill.id;
          self.delData(path, {}, function (res) {
            self.$message({
              message: '删除成功!',
              type: 'success' });

          });
        } else {
          self.$message({
            message: '删除成功!',
            type: 'success' });

        }
        self.handleRemoveModeTitle(targetName);
        self.editableTabs = self.editableTabs.filter(function (otab) {return otab.name !== targetName;});
        self.editableTabsValue = activeName;
        if (self.editableTabs.length === 0) {
          self.handleAddDefault();
          self.editableTabsValue = '11';
        }
      }).catch(function () {});
    },
    handleRemoveModeTitle: function handleRemoveModeTitle(targetName) {
      var self = this;
      var flag = false;
      self.editableTabs.forEach(function (tab) {
        if (flag) {
          var index = parseInt(tab.title.substr(4)) - 1;
          tab.title = '任务序列' + index;
        }
        if (tab.name === targetName) {
          flag = true;
        }
      });
    },
    handleGetParams: function handleGetParams(params) {
      this.$refs.skillParams.handleGetParams(params);
    },
    handleClearParams: function handleClearParams() {
      var self = this;
      if (self.$refs.skillParams) {
        self.$refs.skillParams.handleClearParams();
      }
    },
    onSubmit: function onSubmit() {// 新增提交操作
      // self.handleGetResult()
      /*
      const path = '/api/temi/robot/task/' + self.addData.taskId + '/flow/' + self.addData.flowId + '/taskSkill/' + self.addData.skillId + '/params'
      self.postData(path, self.paramsList, function(res) {
        self.$message({
          message: '添加成功!',
          type: 'success'
        })
      })*/
    } } };exports.default = _default;